//#region Imports
import { useEffect, useState } from 'react';
import { createMaterialTopTabNavigator } from '@react-navigation/material-top-tabs';
import { Text, Platform, SafeAreaView, View, StyleSheet, useWindowDimensions } from 'react-native';
import { useColorScheme } from 'react-native';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@react-navigation/native';
import { useAuthContext } from '../hooks/useAuthContext';
import ShiftsAdmin from '../screens/Shifts/ShortcutPage/ShiftsAdmin';
import CustomLabel from '../components/CustomLabel/CustomLabel';
import { useNavigation } from '@react-navigation/native';
import { useAccount } from '../hooks/useAccount';
import { HRAdminCompanyContextProvider } from '../context/HRAdminCompanyContext';
import withRoleGuard from '../components/withRoleGuard';
import RoleGuard from '../components/RoleGuard';
import useRole from '../hooks/userRole';
import { userRights } from '../hooks/useUserRights';
import { TASKS, TASK_OPTIONS } from '../constants/Tasks';
//#endregion

const Tab = createMaterialTopTabNavigator();

const TopTabNavigationShifts = ({ drawer, }) => {

    //#region Definitions
    const navigation = useNavigation();
    const { width, height } = useWindowDimensions();
    const { hasAccess, hasOptionAccess, isAdmin } = useRole();
    const { getVisibleScreens } = userRights();
    const { t } = useTranslation();
    const { colors } = useTheme()
    const { user } = useAuthContext();
    const { accountGet } = useAccount();
    //! Forcing Light Mode for now
    let colorScheme = useColorScheme();
    colorScheme = 'light';
    // const screenChecks = ['Admin', 'Leaves', 'LeaveApprover', 'Survey', 'Assessments'];
    const [permissions, setPermissions] = useState({});
    const [customWidth, setCustomWidth] = useState(width);
    const styles = makeStyles(colors, width, user, permissions, drawer);
    //#endregion

    //#region RefreshWeb
    //* if refreshed, navigate to last visited page
    const checkIfRefreshed = async () => {
        try {
            let isRefresh = localStorage.getItem('isRefresh');
            if (isRefresh === "true") {
                let lastVisitedScreen = localStorage.getItem('lastVisitedScreen');
                switch (lastVisitedScreen) {
                    case "ShiftsAdmin":
                        navigation.navigate(drawer, { screen: 'ShiftsAdmin' });
                        break;
                    default:
                        navigation.navigate(drawer, { screen: lastVisitedScreen });
                        break;
                };
            };
        } catch (error) {
            console.log(error);
        };
    };

    const accGet = async () => {
        await accountGet().catch(console.error);
    }

    //#endregion

    //#region UseEffects 
    useEffect(
        () => {
            // * No need to do anything here
        },
        [width, height]
    );

    useEffect(() => {

        accGet().then(() => { checkIfRefreshed(); })
    }, [])

    useEffect(() => {
        getVisibleScreens().catch();
    }, []);
    //#endregion
    // * if permissions is not loaded show loading screen 
    if (typeof permissions === 'object' && !Array.isArray(permissions) && permissions === null) {
        return (
            <SafeAreaView
                style={styles.main}>
                <CustomLabel
                    value={t("common:loading")}
                    type="ASSM"
                />
            </SafeAreaView>
        )
    }

    // * Load the top tab navigation for employee or HR administration which is selected from the Drawer Navigation 
    return (
        <SafeAreaView style={{ flex: 1 }}>
            <View style={{ flex: 1, flexDirection: 'column' }}>

                <HRAdminCompanyContextProvider>
                    <Tab.Navigator
                        initialRouteName={'ShiftsAdmin'}
                        backBehavior="order"
                        screenOptions={({ route }) => ({
                            headerShown: false,
                            lazy: true,
                            tabBarScrollEnabled: true,
                            animationEnabled: Platform.OS === 'web' ? false : true,
                            tabBarItemStyle: {
                                width: Platform.OS === 'web' ? width * 0.1 : width < 700 ? width / 4 : width / 3,
                            },
                            tabBarIndicatorStyle: {
                                backgroundColor: colors.top_tab_nav_underline,
                                height: 3,
                            },
                            tabBarStyle: {
                                borderTopWidth: 0,
                                borderTopColor: 'transparent',
                                elevation: 0,
                                shadowOpacity: 0,

                                backgroundColor: colorScheme === 'light' ? '#FFFFFF' : '#000000',
                            },
                            swipeEnabled: false, //! disable swiping for now, since only one tab
                        })}>

                        {<Tab.Screen name="ShiftsAdmin"
                            component={ShiftsAdmin}
                            lazy={false}
                            options={{
                                tabBarLabel: ({ focused, color }) => (
                                    <Text
                                        style={{
                                            fontWeight: focused ? 'bold' : '400',
                                            textAlign: 'center',
                                            width: Platform.OS === 'web' ? width * 0.1 : width < 700 ? width / 4 : width / 3,
                                            fontSize: width < 800 ? 12 : 16,
                                            color: colors.top_tab_nav_text
                                        }}
                                    >{t('navigate:shiftAdmin')}</Text>),
                                title: t('navigate:shiftAdmin'),
                            }}
                        />}
                    </Tab.Navigator >
                </HRAdminCompanyContextProvider>
            </View>

        </SafeAreaView >

    );
};

const makeStyles = (colors, width, user, permissions, drawer, customWidth) => StyleSheet.create({

    margin: {
        alignContent: 'right',
    }
})
export default TopTabNavigationShifts;